Pixlee.module('PhotowallApp', function(PhotowallApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    PhotowallApp.on("start", function(options) {
        new PhotowallApp.Show.Controller(options);
    });
});